// Third party imports
import { createSlice } from "@reduxjs/toolkit";

export const userAuthSlice = createSlice({
  name: "userAuth",
  initialState: {
    refresh: null,
    access: null,
    userType: null,
    operatorId: null,
    companyId: null,
    companyIds: [],
    subdomain: null,
    isAuth: false,
  },
  reducers: {
    setLoginResponse: (state, action) => {
      state.refresh = action.payload.refresh;
      state.access = action.payload.access;
      state.userType = action.payload.user_type;
      state.operatorId = action.payload.operator_id;
      state.companyId = action.payload.company_id ?? null;
      state.companyIds = action.payload.company_ids ?? [];
      state.subdomain = action.payload.subdomain;
    },
    setRefresh: (state, action) => {
      state.refresh = action.payload;
    },
    setAccess: (state, action) => {
      state.access = action.payload;
    },
    setUserType: (state, action) => {
      state.userType = action.payload;
    },
    setOperatorId: (state, action) => {
      state.operatorId = action.payload;
    },
    setCompanyId: (state, action) => {
      state.companyId = action.payload;
    },
    setCompanyIds: (state, action) => {
      state.companyIds = action.payload ?? [];
    },
    setSubdomain: (state, action) => {
      state.subdomain = action.payload;
    },
    setIsAuth: (state) => {
      state.isAuth = true;
    },
    clearRefresh: (state) => {
      state.refresh = null;
    },
    clearAccess: (state) => {
      state.access = null;
    },
    clearUserType: (state) => {
      state.userType = null;
    },
    clearOperatorId: (state) => {
      state.operatorId = null;
    },
    clearCompanyId: (state) => {
      state.companyId = null;
      state.companyIds = [];
    },
    clearSubdomain: (state) => {
      state.subdomain = null;
    },
    clearIsAuth: (state) => {
      state.isAuth = false;
    },
  },
});
export const {
  setLoginResponse,
  setRefresh,
  setAccess,
  setUserType,
  setSubdomain,
  setIsAuth,
  setOperatorId,
  setCompanyId,
  setCompanyIds,
  clearRefresh,
  clearAccess,
  clearUserType,
  clearSubdomain,
  clearOperatorId,
  clearCompanyId,
  clearIsAuth,
} = userAuthSlice.actions;
export default userAuthSlice.reducer;
